try {
    if (process.env.TOKENS_FEATURE_FLAG === 'true' || process.env.STORYBOOK_TOKENS_FEATURE_FLAG !== 'false') require('./index-new.css');
    else require('./index.css');
  } catch (e) {
    if (e.code !== 'MODULE_NOT_FOUND') {
      throw e; // Re-throw unexpected errors
    }
    console.warn('index.css / index-new.css not found, proceeding without it.');
  }


import { jsxs, jsx } from 'react/jsx-runtime';
import { ErrorMessage } from '@design-system/error-message';
import { FieldHead } from '@design-system/field-head';
import { Icon } from '@design-system/icon';
import classNames from 'classnames';
import { forwardRef, useState } from 'react';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
function __rest(s, e) {
  var t = {};

  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
}

var INPUT_TYPE;
(function (INPUT_TYPE) {
    INPUT_TYPE["TEXT"] = "text";
    INPUT_TYPE["PASSWORD"] = "password";
})(INPUT_TYPE || (INPUT_TYPE = {}));

const InputField = forwardRef((_a, ref) => {
    var { className, isHidden = false, isDisabled, inputType, id, label, description, tooltipLabel, tooltipText, tooltipContent, name, value, placeholder, errorMessage, onChange, onBlur, additionalHeadContent } = _a, rest = __rest(_a, ["className", "isHidden", "isDisabled", "inputType", "id", "label", "description", "tooltipLabel", "tooltipText", "tooltipContent", "name", "value", "placeholder", "errorMessage", "onChange", "onBlur", "additionalHeadContent"]);
    const [isShownPassword, setShownPassword] = useState(true);
    const [inputValue, setInputValue] = useState(value);
    const togglePassword = () => {
        setShownPassword(!isShownPassword);
    };
    const handleOnChange = (e) => {
        if (onChange)
            onChange(e);
        setInputValue(e.target.value);
    };
    return (jsxs("div", Object.assign({ className: classNames('cds-input-field', className, {
            'cds-input-field--hidden': isHidden,
        }) }, { children: [jsx(FieldHead, { id: id, label: label, description: description, tooltipLabel: tooltipLabel, tooltipText: tooltipText, tooltipContent: tooltipContent, error: Boolean(errorMessage), additionalHeadContent: additionalHeadContent }), jsxs("div", Object.assign({ className: "cds-input-field__container" }, { children: [jsx("input", Object.assign({ className: classNames('cds-input-field__input', {
                            'cds-input-field__input--error': Boolean(errorMessage),
                            'cds-input-field__input--password': inputType === INPUT_TYPE.PASSWORD,
                            'cds-input-field__input--disabled': isDisabled,
                        }), "aria-invalid": Boolean(errorMessage), id: id, name: name, value: inputValue, placeholder: placeholder, onChange: handleOnChange, onBlur: onBlur, ref: ref, type: isShownPassword && inputType === INPUT_TYPE.PASSWORD
                            ? INPUT_TYPE.PASSWORD
                            : INPUT_TYPE.TEXT }, rest)), inputType === INPUT_TYPE.PASSWORD ? (jsx("button", Object.assign({ "aria-label": "toggle password visibility", onClick: togglePassword, type: "button", className: classNames('cds-input-field__visibility-button', {
                            'cds-input-field__visibility-button--error': Boolean(errorMessage),
                        }) }, { children: jsx(Icon, { size: 10, className: "cds-input-field__visibility-icon", icon: isShownPassword ? 'eye' : 'eye-blocked' }) }))) : null] })), jsx(ErrorMessage, { message: errorMessage })] })));
});

export { InputField };
